import { render, staticRenderFns } from "./CustomSwitch.vue?vue&type=template&id=74c16e6e&scoped=true"
import script from "./CustomSwitch.vue?vue&type=script&lang=js"
export * from "./CustomSwitch.vue?vue&type=script&lang=js"
import style0 from "./CustomSwitch.vue?vue&type=style&index=0&id=74c16e6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c16e6e",
  null
  
)

export default component.exports